import { useIsTeam } from '@upright/ui/common/generic/hooks';
import { useProductsByCode } from '@upright/ui/api/model/input/products';
import { get } from 'lodash';
import { useEffect, useState } from 'react';

type GetIsMappable = (productCode: string) => boolean;

export function useIsMappableProduct() {
  const [getMappable, setGetMappable] = useState<undefined | GetIsMappable>(undefined);
  const productsByCode = useProductsByCode();
  const isTeam = useIsTeam();

  useEffect(() => {
    if (productsByCode) {
      // https://legacy.reactjs.org/docs/hooks-reference.html#lazy-initial-state
      setGetMappable(() => (productCode: string) => get(productsByCode, [productCode, 'mappable'], true));
    } else {
      setGetMappable(undefined);
    }
  }, [productsByCode]);

  return (productCode: string) => (getMappable && isTeam ? getMappable(productCode) : true);
}
